const e = ["#beaff6", "#a590f3", "#7f62ee", "#b646eb"], f = ["#beaff6", "#a590f3", "#9279f1", "#7f62ee", "#b646eb"], b = [
  "#beaff6",
  "#a590f3",
  "#9279f1",
  "#7f62ee",
  "#843edc",
  "#b646eb"
];
export {
  e as TRAFFIC_VOLUME_PLATFORM_4,
  f as TRAFFIC_VOLUME_PLATFORM_5,
  b as TRAFFIC_VOLUME_PLATFORM_6
};
//# sourceMappingURL=index.es5680.js.map
